<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card class="" elevation="" max-width="">
                    <v-card-title class="justify-center"> Lista de Usuarios Logeado con Google </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <!-- Filtros de busqueda -->
                        <v-row>
                            <v-col cols="12" md="2">
                                <v-select
                                    :items="resources.tipoAutenticacion"
                                    label="Tipo de Autenticación"
                                    v-model="filtros.tipo_autenticacion"
                                    @change="getData"
                                ></v-select>
                            </v-col>

                            <v-col cols="12" md="8">
                                 <v-text-field
                                    label="Buscar por nombre"
                                    v-model="filtros.search"
                                    @input="getData"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="2" class="d-flex align-center gap-2">
                                <v-btn color="primary" @click="getData">Buscar</v-btn>
                                <v-btn color="secondary" @click="resetFilters">Limpiar</v-btn>
                            </v-col>
                        </v-row>


                        <v-data-table
                            :headers="table.headers"
                            :items="usuarios.data"
                            :items-per-page="filtros.per_page"
                            class="elevation-1"
                            :options.sync="table.options"
                            :server-items-length="usuarios.total"
                            @update:options="changeOptionsTable"
                        >
                            <template v-slot:item.idusuario="{ item }">
                                {{ item.idusuario.toString().padStart(7,0) }}
                                
                            </template>

                            <template v-slot:item.cliente_nombre="{ item }">
                                <span v-if="item.cliente_nombre">{{ item.cliente_nombre }}</span>
                                <span v-else>N/A</span>
                            </template>

                            <template v-slot:item.idtipo_autenticacion="{ item }">
                                <span v-if="item.tipo_autenticacion">{{ item.tipo_autenticacion.nombre.toUpperCase() }}</span>
                                <span v-else>N/A</span>
                            </template>


                            <template v-slot:item.ultima_conexion="{ item }">
                                <span v-if="item.ultima_conexion">{{ item.ultima_conexion }}</span>
                                <span v-else>Nunca</span>
                            </template>

                        </v-data-table>


                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script >
    import axios from '@/plugins/axios';

    const usuariosGoogle = {
        paginacion(filtros) {
            return axios.get('/api/panel/usuarios/google', { params: filtros });
        },


    }


    export default {
        name: "GoogleList",
        data() {
            return {
                resources: {
                    cantidadRegistros: [
                        { text: '15', value: 15 },
                        { text: '25', value: 25 },
                        { text: '50', value: 50 },
                        { text: '100', value: 100 }
                    ],
                    tipoAutenticacion : [
                        { text: 'TODOS', value: null },
                        { text: 'WEB', value: 1 },
                        { text: 'GOOGLE', value: 2 }
                    ]
                },
                table: {
                    headers: [
                        { text: 'ID', value: 'idusuario' },
                        { text: 'Cliente', value: 'cliente_nombre' },
                        { text: 'Email', value: 'correo' },
                        { text: 'Metodo de Creación', value: 'idtipo_autenticacion' },
                        { text: 'Ultima Conexión', value: 'ultima_conexion' },
                    ],
                    options: {},

                },
                filtros: {
                    search: '',
                    per_page: 15,
                    tipo_autenticacion: null
                },
                usuarios: [],
                paginaActual: 1,
                totalPaginas: 1

            }
        },
        watch: {
            "filtros.per_page": {
                handler (nuevoValor) {
                    this.table.options.itemsPerPage = nuevoValor;
                },
                deep: true,
            }
        },
        methods: {
            async getData({
                page = 1,
                sortBy = null,
                sortDesc = null,
                itemsPerPage = 15
            } = '') {


                try {
                    const res = await usuariosGoogle.paginacion({
                        page: page,
                        per_page: itemsPerPage,
                        search: this.filtros.search,
                        sort_by: sortBy,
                        sort_desc: sortDesc !== null ? (sortDesc ? 'desc' : 'asc') : null,
                        tipo_autenticacion: this.filtros.tipo_autenticacion,
                    });
                    this.usuarios = res.data;
                } catch (error) {
                    console.error(error);
                }
            },

            changeOptionsTable(options) {

                if ( options.itemsPerPage !== this.filtros.per_page ){
                    this.filtros.per_page = options.itemsPerPage;
                }

                this.getData({
                    page: options.page,
                    sortBy: options.sortBy.length > 0 ? options.sortBy[0] : null,
                    sortDesc: options.sortDesc.length > 0 ? options.sortDesc[0] : null,
                    itemsPerPage: options.itemsPerPage
                });
            },

            resetFilters() {
                this.filtros.search = '';
                this.filtros.per_page = 15;
                this.getData();
            },
        }
    }
</script>

<style scoped>
    .gap-2 {
        gap: 8px;
    }
</style>